exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".purchase-with-card[data-v-026b5912],.solution-link[data-v-026b5912]{word-wrap:break-word}.purchase-with-card[data-v-026b5912]{margin-bottom:0}", ""]);

// exports
